import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {
  private API_URL = environment.API_URL;

  constructor(private http: HttpClient) {}

  resetPassword(code: string, password: string) {
    return this.http.post(`${this.API_URL}/auth/reset-password`, {
      code,
      password,
      passwordConfirmation: password
    }, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
  }
}
